webpackJsonp([7],{

/***/ 363:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__(580);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_29ab24dc_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__(952);
function injectStyle (ssrContext) {
  __webpack_require__(939)
}
var normalizeComponent = __webpack_require__(32)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-29ab24dc"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_29ab24dc_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 451:
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ 481:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/msgg.50c593d.png";

/***/ }),

/***/ 482:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/nuha_symbol.ae6332a.png";

/***/ }),

/***/ 483:
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAoCAYAAACM/rhtAAAC0UlEQVRYhe2ZT4hNURzHP+96xpuZxEKyk2IhQjELiuUUERsLs6FINmM3idR9Z0UUFhJmoSYiFqYoKVmNELGhyMTKxJT/aeR57+pMv/s67zrn3Gfq3jvKt16d8zvnnve5v3d+55zfeaUoihDtAHYBPUCZ4vQUuKSUOj9JoAGjKDobTT8NV6tVtAe3AdcL9JhPhzTgI2CNdBoBjgPfCwLqAPqBjVIf04AapksM64D7eRIppVrqYRhqyG8COxEAJaN9Rp5wDv3SYNLUKIsh1izLM/PE5TXgSg6A3UAQAwYpnbcAo8AQcBl4BSzJAbIpH+BcYBiYY9gWA1dzYpuUD3CTo30VsChDphb5AN952nJbhnyAd4EnFvs5YDxDphalBUmvRO5HgToF7MsLjjYOBR/kENEJ1IGfOXE11e6pZaKNPpkoDfAAsEAfeqSup8Qt4LbU9cIeiofNPsf0PioRvxtYCcyXqfJGnh9q54XSAI8ktsIYKgasAActz50B9gCDlra1QB8wAGwAPvkA0oLkpcX23ig3ZGM3pafDSQecqeXAvTAMvQxpgFNRRRb5drQU2Jw3oDkl9M/3GHjh6d/nGywLwFiDsiX2iKf6Hf1W+wbJCvA5sBf4YthOA3csfWeHYegM1qwALzrsIxZbp8xbq7L0oE22A0jg48gK8KvD/sNii4xF/g9lBejKbf4658kKMLn7TFlZLjP/AaeF/nnALoutwyiXJNFOyhWtMy22bl9QpQHWLbaGUY4cfVzrWsNiq/vWwbQDa6+RjyAeGDPadfq5QsZpiCf0S792jHcNeGhctwRSdqax5cTPUUu0j6a8QCPlKJXUZ/k0lbzdkt0m9nSQ3AeLuhdsSilVMy6xAn0/+AxYJoYbwH5JN4uQDpijwE757nENqC/OLyRgknlGXqokIv1EfMuvb7G2FgTl0gNgvfk3xGFgO7Cw4AX8LXBTKTUA8BuwpjSn3ZYhOgAAAABJRU5ErkJggg=="

/***/ }),

/***/ 484:
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACcAAAAnCAYAAACMo1E1AAACPklEQVRYhe2YvWsUQRiHn0vOxBhEbIIpkkIQFARFewXTBWxs1EIQm4gfhb0yN0ErC1E0hSR1ILVgE0HBP0CUQBBJYZWIHwQ1d9HkVl6Zk3Gd7Nfc3B7EHyzc/O6d2efmnXtndypRFGF0EbgAHAd6KEcLwJzW+t7vuwtcFEUzUXdpvlarITN3DpgtaaaSNClwr4AjJugJcBNYLwGmClwDJkx7ReDWgAFjDAPLnSTSWv/VVkrVgZ1AXRZ+ZH038E/vDkop1W9lrSlwm9bt+8uEA/qsStHsdMmo5AmuhuP4oxFTQ08D+2RGgFXgg1n8S2XBXQKmEpbLSBJcyLReAWZS1nE9aYBQcIeBRxniEv+AodJ6dwv/tZmtXtP+nDRICDiZjZMx7ytwFniaZ6AQaT3mKObTecEIBLfH4a0UGSgE3E+HV2hbLOuhMpNCwG04vGa3wH1xeN+KDORbSg4CD2PeXkfcVWA85n0CzifNqi/cEDCWIW6/uWw10tLtm9aGR9/naQG+cH0efd+lBfimVZ7LFmPeLmA05n00l62XoeHeAIdi3gngRcy7D9zOO/i2q3OurarQ2tx221fb9B+uqLoezgZ0lYFOasMqO5WeWCFOfBvKqFVH2FqWrlpreTPbYZpVAXsPHDDGHeCW5/ncsMOTx6jdrmClVOujsFw225/ou5zPXQceWPGNLd4DsqrXukFL8mN/pPSXLA5a7cetA+tnwCkPoHbrLXDUPk2fBM6Yw5VcR1VtlJyqzgM3tNbrvwABKgn0bR3ITAAAAABJRU5ErkJggg=="

/***/ }),

/***/ 580:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var NewsLetter = function NewsLetter() {
  return __webpack_require__.e/* import() */(1/* duplicate */).then(__webpack_require__.bind(null, 324));
};

var SwiperSlider = function SwiperSlider() {
  return __webpack_require__.e/* import() */(59).then(__webpack_require__.bind(null, 944));
};
var ContactAs = function ContactAs() {
  return __webpack_require__.e/* import() */(53/* duplicate */).then(__webpack_require__.bind(null, 442));
};
var LoginModal = function LoginModal() {
  return __webpack_require__.e/* import() */(55/* duplicate */).then(__webpack_require__.bind(null, 458));
};
var RegisterModal = function RegisterModal() {
  return __webpack_require__.e/* import() */(54/* duplicate */).then(__webpack_require__.bind(null, 459));
};
/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    NewsLetter: NewsLetter,
    ContactAs: ContactAs,
    LoginModal: LoginModal,
    RegisterModal: RegisterModal,
    SwiperSlider: SwiperSlider
  },
  data: function data() {
    return {
      propsDatas: {
        title: "Success",
        type: "success",
        direction: "top",
        message: "look at navbar please",
        duration: 1500
      }
    };
  },
  mounted: function mounted() {
    console.log("IIIIIIIIIIInnnnnndeeeeeeeex");
  },

  watch: {},
  computed: {
    isLoggedIn: function isLoggedIn() {
      return this.$store.getters.getCurrentUser && this.$store.getters.getCurrentUser.email && this.$store.getters.getCurrentUser.password;
    },
    user: function user() {
      return this.$store.getters.getCurrentUser;
    }
  },
  methods: {
    msgsend: function msgsend() {
      console.log("############# send");
    },
    bots: function bots() {
      this.$store.dispatch("setAllInfoBotsByUser");
      this.$router.push({
        path: "/application",
        append: true
      });
    },
    newsLetter: function newsLetter() {
      this.$hyModal.show("newsLetter");
    },
    login: function login() {
      this.$hyModal.show("registration");
      //  this.$hyModal.show("login");
    },
    notif: function notif() {
      this.$notif.show(this.propsDatas);
    }
  }
});

/***/ }),

/***/ 939:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(940);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(323)("3e34af5c", content, true, {});

/***/ }),

/***/ 940:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(322)(true);
// imports


// module
exports.push([module.i, ".fullwidth[data-v-29ab24dc]{-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1;-ms-flex-negative:0;flex-shrink:0}.suivre[data-v-29ab24dc]{color:#fff;font-weight:700}.mr-l-25[data-v-29ab24dc]{margin-left:45px}.list-icon[data-v-29ab24dc]{display:-webkit-box;display:-ms-flexbox;display:flex}.list-panel[data-v-29ab24dc]{margin-top:50px;width:75%;margin-left:auto;margin-right:auto}.name-icon[data-v-29ab24dc]{line-height:50px;font-weight:600;font-size:15px}.image_icon[data-v-29ab24dc]{height:70px;margin-left:20px}.msg_nlp[data-v-29ab24dc]{color:#00aeef;font-size:30px;font-weight:750;margin-left:11%;margin-bottom:20px}.img-symbole[data-v-29ab24dc]{margin-left:70px;margin-bottom:10px;max-height:150px}.img-responsive[data-v-29ab24dc]{position:absolute;bottom:0;width:40%}.started[data-v-29ab24dc]{background-color:#000;color:#fff;width:35%;border:transparent;-webkit-box-sizing:border-box;box-sizing:border-box;height:45px;padding:7px 24px 8px;text-align:center;white-space:nowrap;background-image:none;border-width:0;border-radius:9px;cursor:pointer;font-family:Avenir,Helvetica,Arial,sans-serif;font-size:20px;line-height:16px;letter-spacing:.5px}.btn-start[data-v-29ab24dc]{display:-webkit-box;display:-ms-flexbox;display:flex;margin-left:230px;-ms-flex-line-pack:center;align-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;margin-top:90px}", "", {"version":3,"sources":["/usr/msl_nlp/front-bot/src/components/index.vue"],"names":[],"mappings":"AACA,4BAA4B,mBAAmB,oBAAoB,YAAY,oBAAoB,aAAa,CAC/G,AACD,yBAAyB,WAAY,eAAgB,CACpD,AACD,0BAA0B,gBAAgB,CACzC,AACD,4BAA4B,oBAAoB,oBAAoB,YAAY,CAC/E,AACD,6BAA6B,gBAAgB,UAAU,iBAAiB,iBAAiB,CACxF,AACD,4BAA4B,iBAAiB,gBAAgB,cAAc,CAC1E,AACD,6BAA6B,YAAY,gBAAgB,CACxD,AACD,0BAA0B,cAAc,eAAe,gBAAgB,gBAAgB,kBAAkB,CACxG,AACD,8BAA8B,iBAAiB,mBAAmB,gBAAgB,CACjF,AACD,iCAAiC,kBAAkB,SAAW,SAAS,CACtE,AACD,0BAA0B,sBAAuB,WAAY,UAAU,mBAAmB,8BAA8B,sBAAsB,YAAY,qBAAqB,kBAAkB,mBAAmB,sBAAsB,eAAe,kBAAkB,eAAe,8CAAmD,eAAe,iBAAiB,mBAAmB,CAC/X,AACD,4BAA4B,oBAAoB,oBAAoB,aAAa,kBAAkB,0BAA0B,qBAAqB,yBAAyB,sBAAsB,mBAAmB,eAAe,CAClO","file":"index.vue","sourcesContent":["\n.fullwidth[data-v-29ab24dc]{-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1;-ms-flex-negative:0;flex-shrink:0\n}\n.suivre[data-v-29ab24dc]{color:white;font-weight:bold\n}\n.mr-l-25[data-v-29ab24dc]{margin-left:45px\n}\n.list-icon[data-v-29ab24dc]{display:-webkit-box;display:-ms-flexbox;display:flex\n}\n.list-panel[data-v-29ab24dc]{margin-top:50px;width:75%;margin-left:auto;margin-right:auto\n}\n.name-icon[data-v-29ab24dc]{line-height:50px;font-weight:600;font-size:15px\n}\n.image_icon[data-v-29ab24dc]{height:70px;margin-left:20px\n}\n.msg_nlp[data-v-29ab24dc]{color:#00AEEF;font-size:30px;font-weight:750;margin-left:11%;margin-bottom:20px\n}\n.img-symbole[data-v-29ab24dc]{margin-left:70px;margin-bottom:10px;max-height:150px\n}\n.img-responsive[data-v-29ab24dc]{position:absolute;bottom:0px;width:40%\n}\n.started[data-v-29ab24dc]{background-color:black;color:white;width:35%;border:transparent;-webkit-box-sizing:border-box;box-sizing:border-box;height:45px;padding:7px 24px 8px;text-align:center;white-space:nowrap;background-image:none;border-width:0;border-radius:9px;cursor:pointer;font-family:'Avenir', Helvetica, Arial, sans-serif;font-size:20px;line-height:16px;letter-spacing:.5px\n}\n.btn-start[data-v-29ab24dc]{display:-webkit-box;display:-ms-flexbox;display:flex;margin-left:230px;-ms-flex-line-pack:center;align-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;margin-top:90px\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 952:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"hero bg-original is-fullheight bg-img-bottom"},[_c('div',{},[_c('div',{staticClass:"fullwidth"},[_c('div',{staticClass:"columns is-vcentered"},[_c('div',{staticClass:"column is-6"},[_c('div',{staticStyle:{"margin-top":"100px"}},[_vm._m(0),_vm._v(" "),_c('img',{staticStyle:{"margin-top":"20px","margin-left":"20%","width":"60%"},attrs:{"src":__webpack_require__(953)}}),_vm._v(" "),_c('div',{staticClass:"btn-start"},[(!_vm.isLoggedIn)?_c('button',{staticClass:"started",staticStyle:{"margin-left":"23%"},on:{"click":function($event){_vm.login()}}},[_vm._v("Get Started")]):_c('button',{staticClass:"started",staticStyle:{"margin-left":"30%"},on:{"click":function($event){_vm.bots()}}},[_vm._v("Get Started")])])]),_vm._v(" "),_vm._m(1)]),_vm._v(" "),_c('div',{staticClass:"column is-6",staticStyle:{"padding":"0","height":"93vh"}},[_c('swiper-slider'),_vm._v(" "),_c('a',{attrs:{"href":"https://www.facebook.com/messages/t/argotnlu","target":"_blank"}},[_c('img',{staticClass:"image_icon",staticStyle:{"position":"fixed","right":"0%","z-index":"1","font-size":"40px","color":"blue","bottom":"1.6%"},attrs:{"src":__webpack_require__(481)},on:{"click":function($event){_vm.msgsend()}}})]),_vm._v(" "),_c('p',{staticStyle:{"font-weight":"700","right":"6%","font-size":"larger","position":"absolute","bottom":"1%","color":"#0092e0"}},[_vm._v("Collaborative NLU building Engine for developers")])],1)]),_vm._v(" "),_c('news-letter',{attrs:{"id":'newsLetter',"text":'modal newsLetter'}}),_vm._v(" "),_c('contact-as')],1)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-home"},[_c('img',{staticClass:"image_Beta",staticStyle:{"width":"7%"},attrs:{"src":__webpack_require__(451)}}),_vm._v(" "),_c('div',{staticClass:"logo-home"},[_c('img',{staticClass:"img-symbole",attrs:{"src":__webpack_require__(482)}})]),_vm._v(" "),_c('div',{staticClass:"msg_nlp"},[_c('p',[_vm._v("Bring Natural Language to your Solutions...")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"list-panel",staticStyle:{"display":"block","position":"absolute","margin-left":"62px","bottom":"1%"}},[_c('ul',{staticClass:"list-icon"},[_c('li',{staticClass:"suivre",staticStyle:{"margin-top":"8px","font-size":"large","font-weight":"bold"}},[_vm._v("Suivez nous sur")]),_vm._v(" "),_c('li',{staticStyle:{"margin-left":"10px","max-width":"50%"}},[_c('a',{attrs:{"href":"https://www.linkedin.com/company/nuha-ai/","target":"_blank"}},[_c('img',{staticClass:"image_lg",staticStyle:{"max-width":"80%"},attrs:{"src":__webpack_require__(483)}})])]),_vm._v(" "),_c('li',{staticStyle:{"margin-left":"1px","max-width":"50%"}},[_c('a',{attrs:{"href":"https://www.facebook.com/argotnlu/","target":"_blank"}},[_c('img',{staticClass:"image_lg;",staticStyle:{"max-width":"80%"},attrs:{"src":__webpack_require__(484)}})])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 953:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/iconss.7334d73.png";

/***/ })

});


// WEBPACK FOOTER //
// static/js/7.0de094a5b2042b421733.js